export const locale = {
  lang: 'es',
  'text-area-copy': {
    'COPY': 'Copiar',
    'COPIED': 'Copiado'
  }
};
